//
// tiny-slider
// - https://github.com/ganlanyuan/tiny-slider
// - http://ganlanyuan.github.io/tiny-slider/demo
//
// - kickoff = data-js-tns

import { tns } from 'tiny-slider/src/tiny-slider';
import style_vars from '../StyleVariables';
const bps = style_vars.bp_min;


// tns
// -------------------------------------

function tiny_slider(el) {
  let opts;
  const parent_el = el.parentElement;

  // item_settings
  // -------------------------------------

  function item_settings() {
    opts = {
      container: el,
      mode: 'carousel',
      axis: 'horizontal',
      items: 1,
      gutter: 0,
      edgePadding: 0,
      fixedWidth: false,
      autoWidth: false,
      viewportMax: false,
      slideBy: 1,
      center: false,
      controls: true,
      controlsPosition: 'bottom',
      controlsText: ['prev', 'next'],
      controlsContainer: parent_el.querySelectorAll('[data-js-tns-controls-container]')[0],
      prevButton: false,
      nextButton: false,
      nav: false,
      navPosition: 'bottom',
      navContainer: false,
      navAsThumbnails: false,
      arrowKeys: true,
      speed: 0, // speed is set via css
      autoplay: false,
      autoplayPosition: 'top',
      autoplayTimeout: 5000,
      autoplayDirection: 'forward',
      autoplayText: ['play', 'stop'], // can't disable output atm, hidden with css
      autoplayHoverPause: false,
      autoplayButton: false,
      autoplayButtonOutput: false,
      autoplayResetOnVisibility: true,
      animateIn: 'tns-fadeIn',
      animateOut: 'tns-fadeOut',
      animateNormal: 'tns-normal',
      animateDelay: false,
      loop: false,
      rewind: true,
      autoHeight: false,
      lazyload: false,
      lazloadSelector: '.tns-lazy-img',
      touch: true,
      mouseDrag: false,
      swipeAngle: 15,
      preventActionWhenRunning: false,
      preventScrollOnTouch: false,
      nested: false,
      freezable: true,
      disable: false,
      startIndex: 0,
      onInit: false,
      useLocalStorage: true,
    };


    // Non Respnsive Options
    // -------------------------------------

    function set_opt(opt_name, attr) {
      if (el.hasAttribute(attr)) {
        let data_attr = el.getAttribute(attr);
        if (data_attr === 'true' || data_attr === 'false') {
          data_attr = (data_attr === 'true');
        }
        opts[opt_name] = data_attr;
      }
    }

    Object.keys(opts).forEach((opt) => {
      // arg two is converting camelCase to camel-case
      set_opt(opt, 'data-js-tns-' + opt.split(/(?=[A-Z])/).join('-').toLowerCase());
    });


    // Respnonsive Options
    // -------------------------------------

    opts.responsive = {};
    Object.values(bps).forEach((bp) => {
      opts.responsive[parseInt(bp)] = { };
    });

    function set_responsive_opt(bp, opt_name, attr) {
      if (el.hasAttribute(attr)) {
        if (opt_name === 'disable') {
          opts.responsive[bp][opt_name] = (el.getAttribute(attr) === 'true');
        }
        else {
          opts.responsive[bp][opt_name] = Number(el.getAttribute(attr));
        }
      }
    }

    function set_responsive_opt_group(bp_size_name, bp_px_value) {
      set_responsive_opt(parseInt(bp_px_value),  'items',   `data-js-tns-${bp_size_name}-items`);
      set_responsive_opt(parseInt(bp_px_value),  'gutter',  `data-js-tns-${bp_size_name}-gutter`);
      set_responsive_opt(parseInt(bp_px_value),  'disable', `data-js-tns-${bp_size_name}-disable`);
    }

    Object.keys(bps).forEach((key) => {
      set_responsive_opt_group(key, bps[key]);
    });
  }


  // Tiny Slider UX Hack
  // - Plugin disables autoplay after a button click, undo this
  // -------------------------------------

  function tiny_slider_ux_hack(slider) {
    const nav_btns = Array.from(parent_el.querySelectorAll('.bw-tns__nav-btn'));
    nav_btns.forEach((btn) => {
      btn.addEventListener('click', () => {
        setTimeout(() => {
          slider.play();
        }, parseInt(opts.autoplayTimeout) + 1); // make sure transition/animation has finished before restarting
      });
    });
  }


  // init
  // -------------------------------------

  function init() {
    item_settings(el);
    el.tns = tns(opts);
    tiny_slider_ux_hack(el.tns);
  }
  init();
}


// init_all
// ------------------------------------

function init_all() {
  const items = Array.from(document.querySelectorAll('[data-js-tns]'));
  items.forEach(tiny_slider);
}
init_all();
